import styled from 'styled-components'
import React from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import { Text, Hide, getPaletteColor } from 'pcln-design-system'
import { shelfLimitedWidthRange } from '../../constants'

/** = Styles */
const DateTimeText = styled(Text)`
  width: 80px;
  display: inline-grid;
  font-weight: ${(props) => props.theme.bold};
  margin-left: 12px;
  margin-right: 8px;
  justify-content: center;
  max-height: 30px;

  ${(props) => props.theme.flyQueries.mobile} {
    display: flex;
    width: 100%;
    margin-left: 0px;
    margin-right: 0px;
    line-height: 15px;
    justify-content: flex-start;
    margin-bottom: 4px;
  }

  ${(props) => {
    if (props.showFareBrandShelf) {
      return `
        @media ${shelfLimitedWidthRange} {
          margin-right: 0;
        }
      `
    }
    return ''
  }}

  ${(props) => props.theme.flyQueries.desktophd} {
    margin-right: 12px;
  }
`

const DateText = styled(Text)`
  color: ${getPaletteColor('text.base')};
  font-size: 10px;

  ${(props) => props.theme.flyQueries.mobile} {
    margin-right: 4px;
  }

  ${(props) => props.theme.flyQueries.desktoplg} {
    font-size: 12px;
  }
`

const DateTextNoWrap = styled(Text)`
  display: flex;
  white-space: nowrap;
  font-weight: 500;

  ${(props) => props.isHighlighted && `background-color: ${getPaletteColor('alert.light')(props)};`}

  color: ${getPaletteColor('text.base')};
  font-size: 10px;

  ${(props) => props.theme.flyQueries.mobile} {
    margin-right: 4px;
  }

  ${(props) => props.theme.flyQueries.desktoplg} {
    font-size: 12px;
  }
`

/** = Component */
export default function DayDateBox({
  dateTime,
  tripType,
  sliceIndex,
  showFareBrandShelf,
  isFlexDatesOrAltDateExd,
}) {
  const date = moment(dateTime)
  const dayOfTheWeek = date.format('ddd')
  const monthDate = date.format('MM/DD')
  const roundTripDepartHeader = tripType === 'RT'
  const oneWayDepartHeader = tripType === 'OW'
  let sliceType

  if (roundTripDepartHeader || showFareBrandShelf || oneWayDepartHeader) {
    sliceType = sliceIndex === 0 ? 'Depart' : 'Return'
  }

  if (!date.isValid()) {
    return null
  }

  return (
    <DateTimeText
      align='center'
      textAlign='center'
      data-test='detail-dates'
      showFareBrandShelf={showFareBrandShelf}
    >
      {oneWayDepartHeader && (
        <Hide xs>
          {' '}
          <DateText>{sliceType}</DateText>{' '}
        </Hide>
      )}
      {roundTripDepartHeader && <DateText>{sliceType}</DateText>}
      <DateTextNoWrap isHighlighted={isFlexDatesOrAltDateExd} data-test='dates-cntr-seti'>
        {dayOfTheWeek} - {monthDate}
      </DateTextNoWrap>
    </DateTimeText>
  )
}

DayDateBox.defaultProps = {
  alternateType: true,
  showFareBrandShelf: false,
  isFlexDatesOrAltDateExd: false,
}

DayDateBox.propTypes = {
  dateTime: PropTypes.string.isRequired,
  tripType: PropTypes.string,
  sliceIndex: PropTypes.number,
  showFareBrandShelf: PropTypes.bool,
  isFlexDatesOrAltDateExd: PropTypes.bool,
}

DayDateBox.contextTypes = {
  SETI: PropTypes.object,
}
